var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsertbelow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8084_39369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50478 7.75458C2.61417 7.64522 2.76251 7.58378 2.91719 7.58378C3.07187 7.58378 3.22022 7.64522 3.32961 7.75458L6.41719 10.8422V1.75033C6.41719 1.59562 6.47865 1.44724 6.58805 1.33785C6.69744 1.22845 6.84582 1.16699 7.00053 1.16699C7.15524 1.16699 7.30361 1.22845 7.41301 1.33785C7.5224 1.44724 7.58386 1.59562 7.58386 1.75033V10.8422L10.6714 7.75458C10.7815 7.64832 10.9288 7.58952 11.0818 7.59085C11.2347 7.59218 11.381 7.65353 11.4892 7.76168C11.5973 7.86984 11.6587 8.01614 11.66 8.16909C11.6613 8.32204 11.6025 8.46939 11.4963 8.57941L7.41294 12.6627C7.30355 12.7721 7.15521 12.8335 7.00053 12.8335C6.84585 12.8335 6.6975 12.7721 6.58811 12.6627L2.50478 8.57941C2.39542 8.47002 2.33398 8.32167 2.33398 8.16699C2.33398 8.01231 2.39542 7.86397 2.50478 7.75458Z",
    fill: "#4B5563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8084_39369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertbelow);
export default __webpack_public_path__ + "static/media/Insert below.2729dc21e21dbb9bf688dd59b7b133b9.svg";
export { ForwardRef as ReactComponent };